var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-main2"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"alt":"Vue logo","src":require("@/assets/images/logo.png")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }